/* eslint-disable complexity */
import { Icon20Check } from '@vkontakte/icons';
import classNames from 'clsx';
import { isNil } from 'ramda';
import React, { ReactNode, VFC } from 'react';
import { IS_BIZ_USER } from 'reactApp/appHelpers/configHelpers';
import { DropdownTheme } from 'reactApp/ui/DropdownList/DropdownList';
import { HotKeyTip } from 'reactApp/ui/HotKeyTip/HotKeyTip';
import { ArrowUpSmallIcon, Icon20SortOutline, Icon20SortReverseOutline, VerifiedIcon } from 'reactApp/ui/VKUIIcons';

import styles from './DropdownItemAction.css';

interface Props {
    mod?: string;
    asc?: boolean;
    withStatus?: boolean;
    icon?: ReactNode;
    active?: boolean;
    text: string;
    hotkey?: string;
    id?: string;
    theme?: DropdownTheme;
    isSort?: boolean;
}

const renderStatus = ({ active, asc, theme }: { active?: boolean; asc?: boolean; theme?: DropdownTheme }) => {
    if (!active) {
        return <div className={styles.status} />;
    }

    if (isNil(asc)) {
        return theme === DropdownTheme.large ? (
            <div className={classNames(styles.status, styles.rightSideStatus)}>
                <Icon20Check />
            </div>
        ) : (
            <div className={styles.status}>
                <VerifiedIcon />
            </div>
        );
    }

    return (
        <div
            className={classNames(styles.status, {
                [styles.status_flip]: !IS_BIZ_USER && asc,
                [styles.status_right]: IS_BIZ_USER,
            })}
        >
            {IS_BIZ_USER ? (
                <>
                    {asc ? (
                        <Icon20SortOutline data-qa-id={asc ? 'sortAsc' : 'sortDesc'} />
                    ) : (
                        <Icon20SortReverseOutline data-qa-id={asc ? 'sortAsc' : 'sortDesc'} />
                    )}
                </>
            ) : (
                <ArrowUpSmallIcon data-qa-id={asc ? 'sortAsc' : 'sortDesc'} />
            )}
        </div>
    );
};

export const DropdownItemAction: VFC<Props> = ({ mod, asc, icon, text, active, withStatus, hotkey, id, theme, isSort }) => {
    if (isSort) {
        return (
            <div
                className={classNames(styles.root, {
                    [styles[`root_${mod}`]]: Boolean(mod),
                    [styles[`root_${id}`]]: id,
                    [styles.root_mail_sans]: IS_BIZ_USER,
                })}
            >
                {!!icon && IS_BIZ_USER && isSort && (
                    <div className={classNames(styles.icon, styles.icon_blue)}>{active && <Icon20Check />}</div>
                )}
                {!!icon && !IS_BIZ_USER && <div className={styles.icon}>{icon}</div>}
                {!IS_BIZ_USER && withStatus && theme !== DropdownTheme.large && renderStatus({ active, asc, theme })}
                <div className={styles.text}>{text}</div>
                {IS_BIZ_USER && isSort && withStatus && theme !== DropdownTheme.large && renderStatus({ active, asc, theme })}
                {withStatus && theme === DropdownTheme.large && renderStatus({ active, asc, theme })}
                {hotkey && (
                    <div className={styles.hotkeyWrapper}>
                        {' '}
                        <HotKeyTip text={hotkey} />
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className={classNames(styles.root, { [styles[`root_${mod}`]]: Boolean(mod), [styles[`root_${id}`]]: id })}>
            {withStatus && theme !== DropdownTheme.large && renderStatus({ active, asc, theme })}
            {!!icon && <div className={styles.icon}>{icon}</div>}
            <div className={styles.text}>{text}</div>
            {withStatus && theme === DropdownTheme.large && renderStatus({ active, asc, theme })}
            {hotkey && (
                <div className={styles.hotkeyWrapper}>
                    {' '}
                    <HotKeyTip text={hotkey} />
                </div>
            )}
        </div>
    );
};
